export { default as UserGroupSolidIcon } from './UserGroupSolidIcon';
